import { ImportPoCsvBatchResult } from "@redotech/redo-model/inventory/po-csv-upload";
import * as z from "zod";

export const uploadPurchaseOrdersCsv = {
  name: "uploadPurchaseOrdersCsv" as const,
  input: z.object({}),
  output: ImportPoCsvBatchResult,
};
